import React from "react";

// Local YYYY-MM-DD, matching the `date` string the planner API returns.
// toISOString() would report the previous day for any timezone ahead of UTC,
// because these cells are built at local midnight.
const dateKey = (d) => {
  const pad = (n) => String(n).padStart(2, "0");
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
};

const MonthGrid = ({ employees, assignments, monthStart }) => {
  const year = monthStart.getFullYear();
  const month = monthStart.getMonth();

  // Start from first day of month
  const firstDay = new Date(year, month, 1);
  const lastDay = new Date(year, month + 1, 0); // last day of month

  const startDayOfWeek = firstDay.getDay(); // Sunday = 0

  const totalCells = 42; // 6 weeks x 7 days
  const days = [];

  for (let i = 0; i < totalCells; i++) {
    const d = new Date(firstDay);
    d.setDate(d.getDate() - startDayOfWeek + i);

    // Only include current month, otherwise null
    days.push(d.getMonth() === month ? d : null);
  }

  const todayStr = new Date().toDateString();

  return (
    <div className="month-grid">


      {employees.map(emp => (
        <div key={emp.id} className="month-wrap">
          <div className="employee-col">{emp.first_name} {emp.last_name}</div>

            <div className="month-header">
              {["Sun","Mon","Tue","Wed","Thu","Fri","Sat"].map(d => (
                <div key={d} className="month-day-name">{d}</div>
              ))}
            </div>


          <div className="month-row">


          {days.map((d, i) => {
            if (!d) return <div key={i} className="month-cell empty" />;

            // The planner API aliases shift_date to `date` and returns it as a
            // plain YYYY-MM-DD string (db.js sets dateStrings), which is what
            // the week grid matches on too.
            const key = dateKey(d);
            const shift = assignments.find(
              a => a.employee_id === emp.id && a.date === key
            );

            const manual = !!shift?.is_manual;
            return (
              <div key={i} className={`month-cell ${d.toDateString() === todayStr ? "today" : ""} ${shift ? "assigned" : ""} ${manual ? "manual" : ""}`}>
                <span className="date">{d.getDate()}</span>
                {shift && (
                  <>
                    <span
                      className="month-shift-name"
                      title={`${shift.shift_name}${manual ? " — manually edited for this day" : " — default shift"}`}
                    >
                      {shift.shift_name}
                    </span>
                    <div className="shift-dot" />
                  </>
                )}
              </div>
            );
          })}
        </div>
        </div>
      ))}
    </div>
  );
};

export default MonthGrid;
